<template>

		<div>

			<h3>Set permissions</h3>

			<form>
				<ul class="form">
					<li>

						<table class="list" v-if="this.privileges.length > 0">
							<tbody>
								<tr>
									<th></th>
									<th style="width: 70px; text-align: center">View</th>
									<template v-if="!market">
										<th style="width: 70px; text-align: center">Add</th>
										<th style="width: 70px; text-align: center">Edit</th>
										<th style="width: 70px; text-align: center">Delete</th>
									</template>
								</tr>

								<tr v-for="(privilege, index) in privileges" :key="index">
									<template>
										<td>{{privilege.role.name}}</td>
										<td style="width: 70px; text-align: center">
											<label class="center">
												<input type="checkbox" :name="privilege.role.name" :value="market ? '11' : '1'" :checked="checkPrivilege(privilege.value, 'canAccess')">
											</label>
										</td>
										<td style="width: 70px; text-align: center" v-if="!market">
											<label class="center">
												<input type="checkbox" :name="privilege.role.name" value="2" :checked="checkPrivilege(privilege.value, 'canCreate')">
											</label>
										</td>
										<td style="width: 70px; text-align: center" v-if="!market">
											<label class="center">
												<input type="checkbox" :name="privilege.role.name" value="8" :checked="checkPrivilege(privilege.value, 'canUpdate')">
											</label>
										</td>
										<td style="width: 70px; text-align: center" v-if="!market">
											<label class="center">
												<input type="checkbox" :name="privilege.role.name" value="4" :checked="checkPrivilege(privilege.value, 'canDelete')">
											</label>
										</td>
									</template>
								</tr>
							</tbody>
						</table>

					</li>
				</ul>
			</form>

		</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'privileges-sidebar',
	props: {
		data: Object
	},

	watch: {
		data: function (newVal, oldVal) {
			if (newVal.marketData) {
				this.privileges = []
				this.market = newVal.marketData
			} else {
				this.entity = newVal
			}

			this.prepareData()
		}
	},

	data () {
		return {
			roles: null,
			entity: null,
			market: null,
			privileges: []
		}
	},

	created () {
		if (this.data.marketData) {
			this.privileges = []
			this.market = this.data.marketData
		} else {
			this.entity = this.data
		}

		// fetch all roles
		var url = '/cms/api/instances?where[entity]=roles&order=name'
		xhrModule.get(url, this.fetchRolesCompleted.bind(this))
	},

	updated () {
	},

	mounted () {
	},

	methods: {
		fetchRolesCompleted (data) {
			// since these are just instances there are versions of these for each language
			// we don't need those so we can just remove the doubles based on the UUID
			var foundUUIDS = []
			var filteredRoles = []
			for (var key in data.data) {
				var uuid = data.data[key].uuid
				if (foundUUIDS.indexOf(uuid) === -1) {
					// don't show/add the admin role to the interface
					if (uuid === '11EA997CE21A8EA7AC16005056982405') continue

					filteredRoles.push(data.data[key])
					foundUUIDS.push(uuid)
				}
			}

			this.roles = filteredRoles
			this.prepareData()
		},

		prepareData () {
			if ((this.entity && this.roles) || (this.market && this.roles)) {
				var privileges = []
				// set known privileges
				if (this.entity) {
					if (this.entity.privileges) privileges = Object.values(this.entity.privileges)
				}

				if (this.market) {
					if (this.market.privileges) privileges = Object.values(this.market.privileges)
				}

				for (var key in this.roles) {
					// check if a permission for this role exists
					var exists = false
					var foundPiv = null
					for (var i = privileges.length - 1; i >= 0; i--) {
						if (this.roles[key].uuid === privileges[i].role.id) {
							exists = true
							foundPiv = privileges[i]
						}
					}

					if (!exists) {
						// create the default privilege for this role
						var priv = {
							'id': 0,
							'role': {
								'id': this.roles[key].uuid,
								'name': this.roles[key].data.name.value
							},
							'state': 3,
							'value': 0
						}

						this.privileges.push(priv)
					} else {
						this.privileges.push(foundPiv)
					}
				}
			}
		},

		save () {
			// check the values for each role
			this.getCheckboxValues(function (values) {
				// set privileges with new values
				for (var i = this.privileges.length - 1; i >= 0; i--) {
					// the value can be 0
					if (values[this.privileges[i].role.name] > -1) this.privileges[i].value = values[this.privileges[i].role.name]

					if (i === 0) {
						var json = null
						var url = null

						if (this.entity) {
							this.entity['privileges'] = this.privileges
							json = JSON.stringify(this.entity)
							url = '/cms/api/entities'
						} else if (this.market) {
							this.market['privileges'] = this.privileges
							json = JSON.stringify(this.market)
							url = '/cms/api/markets'
						}

						xhrModule.post(url, json, this.postEntityPrivileges.bind(this))
					}
				}
			}.bind(this))
		},

		postEntityPrivileges (data) {
			// this.entity = data
			if (this.entity) {
				this.entity = data.data
			} else if (this.market) {
				this.market = data.data
			}

			general.saveAnimation()
			this.$parent.toggle()
		},

		getCheckboxValues (callback) {
			var form = this.$el.querySelector('form')
			var checkboxes = form.querySelectorAll('input[type="checkbox"]')
			var values = {}

			for (var i = checkboxes.length - 1; i >= 0; i--) {
				var existingValue = 0
				var value = 0
				var checkboxName = checkboxes[i].getAttribute('name')
				if (checkboxes[i].checked) {
					value = parseInt(checkboxes[i].value)
				}

				if (values[checkboxName]) existingValue = values[checkboxName]
				values[checkboxName] = existingValue + value

				if (i === 0) {
					callback(values)
				}
			}
		}
	}
}

</script>
